// Ignore call to setInterval and setTimeout because:
// - React calls setTimeout and we cannot disable this
// - React.NET checks if setTimeout exists and creates a function that throws an error if it doesn't:
//   https://github.com/reactjs/React.NET/blob/master/src/React.Core/Resources/shims.js
//
// This results in React calling the setTimeout function of React.NET which throws an error
import canUseDOM from './canUseDOM';
import { TextEncoder, TextDecoder } from 'text-encoding-utf-8';
const mockServersideFunction = (checkFunctionName, functionNames) => {
    if (canUseDOM)
        return;
    if (typeof globalThis[checkFunctionName] !== 'function' ||
        globalThis[checkFunctionName].length === 0 // Because they are empty functions on the server: function() { throw new Error(...) };
    ) {
        functionNames.forEach((functionName) => {
            globalThis[functionName] = () => undefined;
        });
    }
};
mockServersideFunction('setTimeout', ['setTimeout', 'clearTimeout']);
mockServersideFunction('setInterval', ['setInterval', 'clearInterval']);
// Make sure TextEncoder and TextDecoder are globally available for React 18 SSR
// This is crucial for server-side rendering in React 18
if (!canUseDOM) {
    if (typeof globalThis.TextEncoder === 'undefined') {
        globalThis.TextEncoder = TextEncoder;
    }
    if (typeof globalThis.TextDecoder === 'undefined') {
        globalThis.TextDecoder = TextDecoder;
    }
}
